module.exports = __webpack_public_path__ + "img/horizontal-logo.e496ca61.svg";